












































































































































































































































































































































































































































































    import { Component, Watch, RightHelper, tlStore } from "../../../Infrastructure/CorBase/CoreBase";
	import ComponentDetailBase from "./ComponentDetailBase";

	@Component
	export default class ComponentDetail extends ComponentDetailBase {
	

		created() {
			this.createdBase();
			this.mainDataChanged = false;
			super.initializeRights('COR_Component_Create', 'COR_Component_Delete', 'COR_Component_Read', 'COR_Component_Update');
			super.setMainDescription('component.new', 'component.detail');
            super.setTimer(5);
		}

		deleteMessageItem = null;
		showDeleteMessage(item: any) {
			if (tlStore.state.askBeforeDelete) {
                this.deleteMessageItem = item;
				this.$bvModal.show('deleteMessage');
			}
			else {
				this.removeHistoryItem(item);
			}
		}

		showButtonMessageHistory() {
			return RightHelper.currentUserHasRight('COR_Message_Read') && !this.formIsInEditMode;
		}

		showRemoveItemButton() {
            return RightHelper.currentUserHasRight('COR_Message_Update');
		}

		allowRemoveItemHistory() {
			return true;
		}

		removeHistoryItem(item: any) {
			if (item == undefined) {
				item = this.deleteMessageItem;
			}
			this.cancelComponentMessage(item);
		}

        showParams(show: boolean) {
            this.showParamsDetail = !show;
        }

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && (this.mainDataChanged || this.mainDataChangedSub)) {
                event.preventDefault(); event.returnValue = "";
            }
        }
      
        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

		beforeDestroy() {
            clearInterval(this.timerHandle);
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}

		mounted() {
			super.mounted();
		};	


		isNotRun = true;
        @Watch('isTranscoder')
        onPropertyChanged(value: boolean, oldValue: boolean) {
			if (value !== oldValue) {
				if (value == true && this.isNotRun) {
					this.isNotRun = false;
                    this.timerHandle = setInterval(() => {
                        this.timerRefresh();
                    }, this.timerSecondRefresh);
                }
            }
        }

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		isCorrectComponentId(value: any) {
			this.isCorrectComponentIdBase(value);
		}

      
	}
